var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-viewer preview-yiqixie-viewer"},[(_vm.link)?_c('iframe',{attrs:{"src":_vm.link,"id":"yiqixie_frame","name":"yiqixie_frame"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }